var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#00acd7}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8 27.3c-.1 0-.2-.1-.1-.2l.7-.8c.1-.1.2-.2.3-.2h11.1c.1 0 .2.1.1.2l-.5.8c-.1.1-.2.2-.3.2H4.8zM.1 30.2c-.1 0-.1-.1-.1-.2l.7-.8c0-.1.2-.2.3-.2h14.2c.1 0 .2.1.2.2l-.2.7c0 .1-.2.2-.3.2l-14.8.1zM7.7 33c-.1 0-.2-.1-.1-.2l.4-.7c.1-.1.2-.2.3-.2h6.2c.1 0 .2.1.2.2l-.1.7c0 .1-.1.2-.2.2H7.7zM40 26.7l-5.2 1.4c-.5.1-.5.2-.9-.3-.5-.5-.8-.9-1.5-1.2-2-1-3.9-.7-5.6.5-2.1 1.4-3.2 3.4-3.2 5.9 0 2.5 1.7 4.5 4.2 4.9 2.1.3 3.9-.5 5.3-2.1.3-.3.5-.7.8-1.2h-6c-.7 0-.8-.4-.6-.9.4-1 1.2-2.6 1.6-3.4.1-.2.3-.5.8-.5H41c-.1.8-.1 1.7-.2 2.5-.3 2.2-1.2 4.3-2.6 6.1-2.2 3-5.2 4.8-8.9 5.3-3.1.4-5.9-.2-8.4-2.1-2.3-1.7-3.6-4.1-4-6.9-.4-3.4.6-6.4 2.6-9.1 2.2-2.9 5.1-4.7 8.7-5.4 2.9-.5 5.7-.2 8.3 1.5 1.7 1.1 2.8 2.6 3.6 4.4.4.4.3.5-.1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3 44c-2.8-.1-5.4-.9-7.6-2.7-1.8-1.6-3-3.6-3.4-6-.6-3.5.4-6.6 2.5-9.4 2.3-3 5-4.5 8.7-5.2 3.2-.6 6.2-.2 8.9 1.6 2.5 1.7 4 4 4.4 6.9.5 4.2-.7 7.6-3.6 10.6-2.1 2.1-4.6 3.4-7.5 4-.7 0-1.6.1-2.4.2zm7.4-12.6c0-.4 0-.7-.1-1-.6-3.1-3.4-4.8-6.4-4.1-2.9.7-4.8 2.5-5.5 5.4-.6 2.4.6 4.9 2.9 5.9 1.7.7 3.4.7 5.1-.2 2.5-1.4 3.9-3.4 4-6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolangIcon);
export default __webpack_public_path__ + "static/media/golang-icon.85082dda5980960d177c2138840a007d.svg";
export { ForwardRef as ReactComponent };